import type { RootState } from '@/store/store';

export const selectLocale = (state: RootState) => state.settings.locale;
export const selectSidebarCollapsed = (state: RootState) => state.settings.sidebarCollapsed;
